'use client';
import { useEffect, useRef } from 'react';

import { wcPromotionMissionService } from '@/domains/wc-promotion/services/wc-promotion-mission.service';
import { useWcPromotionMissionTracker } from '@/domains/wc-promotion/hooks/use-wc-promotion-mission-tracker';

export const WcMissionTracker = () => {
	const { completeWcMission } = useWcPromotionMissionTracker();
	const completeWcMissionRef = useRef(completeWcMission);

	useEffect(() => {
		completeWcMissionRef.current = completeWcMission;
	});

	useEffect(() => {
		const subscription = wcPromotionMissionService.mission$.subscribe(payload => {
			completeWcMissionRef.current(payload);
		});
		return () => {
			subscription.unsubscribe();
		};
	}, []);

	return null;
};